import { render, staticRenderFns } from "./InlinedLoader.vue?vue&type=template&id=bde6aee2&scoped=true&"
import script from "./InlinedLoader.vue?vue&type=script&lang=js&"
export * from "./InlinedLoader.vue?vue&type=script&lang=js&"
import style0 from "./InlinedLoader.vue?vue&type=style&index=0&id=bde6aee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde6aee2",
  null
  
)

export default component.exports